/* eslint-disable sonarjs/cognitive-complexity */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import * as Yup from 'yup';
import { Col, Row } from 'antd';
import { Form, Select, Input } from 'formik-antd';
import { useDispatch } from 'react-redux';
import { Box, FormInput, CustomInput, Button, Text } from 'atoms';
import { validateMobileNumber } from '../FormValidation';
import { getPincodeList } from 'store/pageSlice';
import { Debug } from '../Debug';
import { addClient, updateInfoClient } from 'store/clientSlice';
import {
	gender_list_data,
	legal_structure_data,
	mobileError,
	pinError,
	primary_cost_data,
} from 'utils/config';
import { ACL, EditModeBtn } from 'components/common';
// import { useQuery } from 'hooks';
import { CancelButton } from 'utils/commonStyled';
export default function ClientInfoForm({ isEditMode = false, formData = {}, otherFormsData }) {
	console.log('isEditMode ', isEditMode);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const formRef = useRef();
	// const [query] = useQuery();
	const [editMode, setEditMode] = useState(false);
	const [isCreate, setIsCreate] = useState(false);
	console.log(otherFormsData);
	const FormSchema = useMemo(
		() =>
			Yup.object({
				client_name: Yup.string()
					.required()
					.min(3)
					.max(63)
					.label('Client Name')
					.matches(
						/^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/,
						'Client name should be alpha-numeric'
					),
				short_name: Yup.string()
					.min(3)
					.required()
					.max(16)
					.label('Short Name')
					.matches(
						/^([a-zA-Z0-9]+\s)*[a-zA-Z0-9]+$/,
						'Short name should be alpha-numeric'
					),
				cp_first_name: Yup.string()
					.min(1)
					.max(32)
					.label('Contact Person First Name')
					.matches(
						/^[a-zA-Z]*$/,
						'Contact Person First Name should only contain alphabets'
					),
				cp_middle_name: Yup.string()
					.min(1)
					.max(32)
					.label('Contact Person Middle Name')
					.matches(
						/^[a-zA-Z]*$/,
						'Contact Person Middle Name should only contain alphabets'
					),
				cp_last_name: Yup.string()
					.min(1)
					.max(32)
					.label('Contact Person last Name')
					.matches(
						/^[a-zA-Z]*$/,
						'Contact Person last Name should only contain alphabets'
					),
				email: Yup.string().required().email('Must be a valid email').label('Email'),
				password: Yup.string()
					.label('Password')
					.min(6)
					.max(12)
					.when([], {
						is: () => !isEditMode,
						then: Yup.string().required(),
						otherwise: Yup.string().notRequired(),
					}),
				mobile_number: Yup.string()
					.required()
					.label('Mobile Number')
					.min(10, mobileError)
					.max(10, mobileError)
					.test('Not a valid Mobile Number', (value) => validateMobileNumber(value)),
				alternate_number: Yup.string()
					.nullable()
					.label('Alternative Mobile Number')
					.min(10, mobileError)
					.max(10, mobileError)
					.test('Not a valid Alternative Mobile Number', (value) =>
						validateMobileNumber(value)
					),
				address: Yup.string().required().min(6).max(200).label('Address'),
				zone: Yup.string().label('Zone').required(),
				state: Yup.string().label('State').required(),
				city: Yup.string().label('City').required(),
				pin_code: Yup.string()
					.required()
					.label('Pin Code')
					.min(6, pinError)
					.max(6, pinError)
					.matches(/^[0-9]*$/, 'Please enter valid pin code'),
				primary_cost_center: Yup.string().required().label('Primary Cost'),
				legal_structure: Yup.string().required().label('Legal Structure'),
				cp_gender: Yup.string()
					.label('Gender')
					.matches(/^[a-zA-Z]*$/, 'Please enter valid Gender'),
			}),
		[isEditMode]
	);

	const initialValues = useMemo(
		() => ({
			client_name: formData?.client_name || undefined,
			short_name: formData?.short_name || undefined,
			legal_structure: formData?.legal_structure || undefined,
			primary_cost_center: formData?.primary_cost_center || undefined,
			email: formData?.email || undefined,
			mobile_number: formData?.mobile_number || undefined,
			password: undefined,
			cp_gender: formData?.cp_gender || undefined,
			alternate_number: formData?.alternate_number || undefined,
			address: formData?.address || undefined,
			zone: formData?.zone || undefined,
			state: formData?.state || undefined,
			city: formData?.city || undefined,
			pin_code: formData?.pin_code || undefined,
			cp_first_name: formData?.cp_first_name || undefined,
			cp_middle_name: formData?.cp_middle_name || undefined,
			cp_last_name: formData?.cp_last_name || undefined,
		}),
		[formData]
	);

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		let payload = {};

		if (isEditMode) {
			payload.update_type = 'client';
			payload = {
				data: values,
				ids: otherFormsData,
			};

			dispatch(
				updateInfoClient({
					req_data: payload,
					setErrors,
					isEditMode,
				})
			)
				.then((res) => {
					window.location = `${window.origin}/client/edit/${res.data.id}?tab=2`;
					setSubmitting(false);
				})
				.catch((res) => {
					setErrors(res?.response?.data?.error?.message);
					setSubmitting(false);
				});
		} else {
			payload = {
				data: values,
			};
			payload.create_type = 'client';
			dispatch(addClient({ req_data: payload, setErrors, isEditMode }))
				.then((res) => {
					window.location = `${window.origin}/client/edit/${res.data.id}?tab=2`;
					setSubmitting(false);
				})
				.catch((res) => {
					console.log(res);
					setErrors(res?.response?.data?.error?.message);
					setSubmitting(false);
				});
		}
	};

	function handlePicodeChange(e) {
		const pin_code = e?.target?.value;

		if (pin_code?.length === 6) {
			dispatch(getPincodeList(pin_code))
				.then((res) => {
					console.log('pincode response', res?.rows[0]);
					const { city, state, zone } = res?.rows?.[0] || {};
					if (formRef?.current) {
						formRef.current?.setFieldValue('city', city);
						formRef.current?.setFieldValue('state', state);
						formRef.current?.setFieldValue('zone', zone);
					}
				})
				.catch((er) => {
					console.log('pincode error', er);
				});
		} else {
			console.log('not a valid pincode');
			if (formRef?.current) {
				formRef.current?.setFieldValue('city', undefined);
				formRef.current?.setFieldValue('state', undefined);
				formRef.current?.setFieldValue('zone', undefined);
			}
		}
	}
	function handleEdit() {
		console.log('before isEditable mode ', editMode);
		setEditMode(!editMode);
		console.log('after isEditable mode ', editMode);
	}

	useEffect(() => {
		setIsCreate(location.pathname.split('/').pop() === 'addsection');
	});

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
			innerRef={formRef}
			initialTouched={{
				zone: true,
				state: true,
				city: true,
			}}
		>
			{({ errors }) => (
				<Box>
					<ACL action="update" module="client">
						{isEditMode && (
							<Row gutter={16} justify="space-between">
								<div></div>
								<EditModeBtn handleEdit={handleEdit} />
							</Row>
						)}
					</ACL>
					<Form className={editMode === false && !isCreate ? 'disabled-div' : ''}>
						<Box padding="1.5rem 2rem" background="#fff">
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="client_name" label="Client Name *">
										<CustomInput name="client_name" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="short_name" label="Short Name *">
										<CustomInput name="short_name" />
									</FormInput>
								</Col>
							</Row>

							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="legal_structure" label="Legal Structure *">
										<Select
											name="legal_structure"
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											}
											placeholder="Select"
											options={legal_structure_data}
										/>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput
										name="primary_cost_center"
										label="Primary Cost Center *"
									>
										<Select
											name="primary_cost_center"
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											}
											placeholder="Select"
											options={primary_cost_data}
										/>
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput
										name="cp_first_name"
										label="Contact Person First Name"
									>
										<CustomInput name="cp_first_name" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput
										name="cp_middle_name"
										label="Contact Person Middle Name"
									>
										<CustomInput name="cp_middle_name" />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="cp_last_name" label="Contact Person Last Name">
										<CustomInput name="cp_last_name" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="cp_gender" label="Gender *">
										<Select
											name="cp_gender"
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											}
											placeholder="Select"
											options={gender_list_data}
										/>
									</FormInput>
								</Col>
							</Row>

							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="email" label="Email Address *">
										<CustomInput
											name="email"
											autoComplete="new-password"
											role="presentation"
										/>
									</FormInput>
								</Col>
								<Col lg={12}>
									{!isEditMode && (
										<FormInput name="password" label="Password *">
											<Input.Password
												name="password"
												autoComplete="new-password"
												role="presentation"
											/>
										</FormInput>
									)}
								</Col>
							</Row>

							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="mobile_number" label="Mobile Number *">
										<CustomInput name="mobile_number" maxLength={10} />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput
										name="alternate_number"
										label="Alternate Mobile Number"
									>
										<CustomInput name="alternate_number" maxLength={10} />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="address" label="Address *">
										<CustomInput name="address" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput
										name="pin_code"
										label="Pin Code *"
										onChange={handlePicodeChange}
									>
										<CustomInput
											name="pin_code"
											disabled={isEditMode}
											maxLength={6}
										/>
									</FormInput>
								</Col>
							</Row>

							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="zone" label="Zone *">
										<CustomInput name="zone" disabled />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="state" label="State *">
										<CustomInput name="state" disabled />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="city" label="City *">
										<CustomInput name="city" disabled />
									</FormInput>
								</Col>
								<Col lg={12}>
									{errors?.zone && (
										<Text mt="2.5rem" color="red">
											Please enter valid pincode. Zone, State, City are
											Required *
										</Text>
									)}
								</Col>
							</Row>
						</Box>

						<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
							<CancelButton onClick={() => navigate('/client-list')} type="button">
								Cancel
							</CancelButton>
							<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
								{isEditMode ? 'Update' : 'Submit'}
							</Button>
						</Box>
						<Debug />
					</Form>
				</Box>
			)}
		</Formik>
	);
}

ClientInfoForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	otherFormsData: PropTypes.object,
};
